import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import {
  RadialBarChart,
  RadialBar,
  Legend,
  PieChart,
  Pie,
  Cell,
  Sector,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts';
import moment from 'moment';
import { Icon, Image } from 'semantic-ui-react';
import './DashboardGraph.css';

class DashboardGraph extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { type, whole, piece, monthData, graphColor, title, emptyComponent, message, centerImage } = this.props;

    // 월별 훈련 그래프(막대)
    const barData = [];
    if (monthData && monthData.length > 0) {
      let before = 9;
      // 최근 10개월 훈련
      for (let i = before; i >= 0; i--) {
        const graphMonth = moment().subtract(i, 'months').format("YYYY-MM");
        let isMon = false;
        monthData.map(mon => {
          if (mon.month == graphMonth) {
            barData.push(mon);
            isMon = true;
          }
        })
        if (!isMon) {
          barData.push({ count: 0, month: graphMonth })
        }
      }
    }

    // 훈련 결과 그래프(원)
    const activePercent = piece && whole ? Number((piece / whole * 100).toFixed(0)) : 0;
    const pieData = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: 100 - activePercent,
        percent: 100 - activePercent
      },
      {
        name: message,
        color: graphColor,
        value: activePercent,
        percent: activePercent
      }
    ];

    return (
      <div className="dashboard-graph-item">
        {title &&
          <div className="common-title">
            {title}
          </div>}
        {type === 'bar' &&
          (barData && barData.length > 0
            ?
            <BarChart width={360} height={360} data={barData}
              margin={{ top: 50, right: 25, bottom: 0, left: -25 }}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip
                cursor={false}
                content={({ payload }) => {
                  return (
                    <div>
                      {payload && payload.map((entry, index) => (
                        <div className={'graph-tooltip'} key={index}>
                          <div className={'name'}>{entry.payload.month}</div>
                          <div className={'value'} style={{ color: graphColor }}>
                            {entry.payload.count + defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                }}
              />
              {/* <Legend /> */}
              <Bar dataKey="count" fill={graphColor} barSize={15} />
            </BarChart>
            : (
              emptyComponent
            )
          )
        }
        {type === 'pie' && pieData &&
          <div className="pie-chart">
            <div className={'pie-icon'}>
              <Image src={centerImage} />
            </div>
            <PieChart width={180} height={300}>
              <Pie
                dataKey="percent"
                data={[
                  {
                    name: 'background',
                    percent: 100
                  }
                ]}
                // cx={55}
                // cy={55}
                innerRadius={60}
                outerRadius={80}
                startAngle={90}
                endAngle={450}
                paddingAngle={0}>
                <Cell fill="#e6e6e6" />
              </Pie>
              <Pie
                dataKey="percent"
                data={pieData}
                // cx={55}
                // cy={55}
                innerRadius={60}
                outerRadius={80}
                startAngle={90}
                endAngle={450}
                paddingAngle={0}
                activeIndex={0}
                activeShape={e => {
                  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, value } = e;
                  return (
                    <g>
                      {/* <text x={cx} y={cy} dy={8} textAnchor="middle" fill={'#838383'}>{message}</text> */}
                      {/* 그라데이션 효과 */}
                      {/* <defs>
                  <linearGradient id="db2828" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#ff6c00" />
                    <stop offset="100%" stopColor="#ff0b72" />
                  </linearGradient>
                </defs> */}
                      <defs>
                        <linearGradient id={graphColor.replace('#', '')} x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor={graphColor} />
                          <stop offset="100%" stopColor={graphColor} />
                        </linearGradient>
                      </defs>
                      <Sector
                        cx={cx}
                        cy={cy}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        fill="rgb(230,230,230)"
                      />
                      {/* 차트의 확장 처리 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        innerRadius={outerRadius}
                        outerRadius={outerRadius}
                        cornerRadius={10}
                      />
                    </g>
                  );
                }}>
                {/* cell 안에 그라데이션 효과 */}
                {pieData.map((entry, index) => {
                  return (
                    <Cell cornerRadius={10} key={index} fill={'url(' + entry.color + ')'} />
                  )
                })}
              </Pie>
              <Legend
                content={({ payload }) => {
                  return (
                    payload.map((entry, index) => {
                      if (!!entry.value && entry.value !== "background") {
                        return (
                          <div className={'graph-legend'} key={index}>
                            <div className={'color'} style={{ backgroundColor: entry.payload.color }} />
                            <div className={'message'}>
                              <span>{entry.payload.name}</span>
                              <span>{entry.payload.value + "%"}</span>
                            </div>
                          </div>
                        );
                      }
                    })
                  );
                }}
              />
              <Tooltip
                content={({ payload }) => {
                  return payload.map((entry, index) => {
                    if (!!entry.payload.name) {
                      return (
                        <div className={'graph-tooltip'} key={index}>
                          <div className={'name'}>{entry.payload.name}</div>
                          <div className={'value'} style={{ color: graphColor }}>
                            {entry.value + '%'}
                          </div>
                        </div>
                      );
                    }
                  });
                }}
              />
            </PieChart>

          </div>
        }
      </div>
    )
  }
}

export default injectIntl(DashboardGraph);


// WEBPACK FOOTER //
// ./src/script/components/dashboard/DashboardGraph.js